<div [formGroup]="form">
  <ejs-dropdownlist #dropDownList
                    [id]="id"
                    [width]="width"
                    [showClearButton]="showClearButton"
                    [dataSource]="enumSelectionData"
                    [placeholder]="placeholder | translate"
                    [fields]="fields"
                    formControlName="formValue"
                    popupWidth="auto">
    <ng-template #itemTemplate let-data>
      {{data.text | translate}}
    </ng-template>
    <ng-template #valueTemplate let-data>
      <span class="full-height">{{data.text | translate}}</span>
    </ng-template>
  </ejs-dropdownlist>
</div>
